import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, DestroyRef, inject } from '@angular/core';
import { LoginService } from '../../../core/services/login.service';
import { SessionStorageService } from '../../../core/services/session-storage.service';
import { OpenidOauthConfig } from '../../models/login/OpenidOauthConfig';
import { UtilsService } from '../../../core/services/utils';
import { OpenidProviderComponent } from '../openid-provider/openid-provider.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'facebook-signin',
    templateUrl: './facebook-signin.component.html',
    styleUrls: ['./facebook-signin.component.scss'],
    standalone: true
})
export class FacebookSigininComponent extends OpenidProviderComponent implements AfterViewInit {
  private readonly facebookLogin = '{issuer}?client_id={clientId}&response_type=token&redirect_uri={redirectUri}&state={state}&scope={scope}';
  private readonly facebook = 'facebook';
  @Input()
  private challenge: string;
  private redirectUrl: string;
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(DOCUMENT) private document: any,
              private loginService: LoginService,
              private sessionStorageService: SessionStorageService,
              private utils: UtilsService) {
    super();
    this.openIdSettingsErrorSubscriber = this.openIdSettingsSubscriber.bind(this);
    this.openIdSettingsSubscriber = this.openIdSettingsSubscriber.bind(this);
  }

  public ngAfterViewInit() {
    this.loginService.getOAuthSettings(this.challenge, this.facebook)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.openIdSettingsSubscriber, this.openIdSettingsErrorSubscriber);
  }

  public facebookSignIn() {
    this.document.location.href = this.redirectUrl;
  }

  private openIdSettingsSubscriber(res: OpenidOauthConfig) {
    const {issuer, clientId, redirectUri, scope} = res;
    const hydraNonce = this.sessionStorageService.value('nonce');

    const customParams = {'nonce': hydraNonce, 'challenge': this.challenge, 'provider': this.facebook};
    const state = super.encodeCustomParams(customParams);
    const url = this.utils.parseTemplateString(this.facebookLogin, {
      issuer, clientId, redirectUri, state, scope
    });
    this.redirectUrl = url;

  }

  private openIdSettingsErrorSubscriber(err) {
    const error = super.getErrorMsg(err);
    console.error(error);
  }
}
